"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var CityState = function CityState(_ref) {
  var _ref$address = _ref.address,
    address = _ref$address === void 0 ? {} : _ref$address;
  var hasCity = !(0, _lodash.isEmpty)(address.city);
  var hasState = !(0, _lodash.isEmpty)(address.state);
  if (hasCity && hasState) {
    return /*#__PURE__*/_react["default"].createElement("span", null, address.city, ", ", /*#__PURE__*/_react["default"].createElement("abbr", null, address.state, " "));
  }
  if (hasCity) {
    return /*#__PURE__*/_react["default"].createElement("span", null, address.city, " ");
  }
  if (hasState) {
    return /*#__PURE__*/_react["default"].createElement("span", null, address.state, " ");
  }
  return null;
};
CityState.propTypes = {
  address: _propTypes["default"].shape({
    city: _propTypes["default"].string,
    state: _propTypes["default"].string
  }).isRequired
};
var _default = exports["default"] = CityState;